/*jslint eqeq: true, nomen: true, plusplus: true, unparam: true, todo: true, vars: true, browser: true, indent: 3, maxerr: 50 */
//window.Century21.Setup.mapModule(function ($, C21, C21Maps, BingMaps) {
define(['jquery', 'c21/ajax', 'c21/maps', 'c21/maps/TooltipManager', 'c21/SchoolSearch'], function ($, ajax, C21Maps, TooltipManager, SchoolSearch) {
   "use strict";

   return function (map) {
      var self = this,
         m_map = map,
         m_schoolPinLayer,

         m_jHoverTemplate = $("<div class='schoolSummaryHoverOverlay'><div class='contentTip'></div></div>"),
         m_jClickTemplate = $("<div class='schoolSummaryClickOverlay'><div class='contentTip'></div></div>"),

         initClickTooltip = function (jTooltip, pinData) {
            jTooltip.find(".modalCloseDiv").click(m_tooltipManager.hideClickTooltip);
         },

         initShape = function (jTooltip, pinData) {
            var strId = pinData.getId(),
               strHtml = jTooltip.html(),
               aShapeCoordinates = SchoolSearch.parseBoundary(strId, strHtml);

            m_schoolPinLayer.addShape(strId, aShapeCoordinates);
         },

         getAjaxTooltip = function (strSchoolId, fnCallback) {
            ajax.doViewEngineAjax('SchoolSummaryOverlay', '/schoolsearch/summary',
               $.param({
                  sid: strSchoolId
               }), {
                  callback: fnCallback
               });
         },

         doTooltipHtml = function (pinData, strQuery) {
            return $.Deferred(function (dfd) {
               var strId = pinData.getId();

               getAjaxTooltip(strId, function () {
                  var jAjaxInfo = $(strQuery),
                     strHtml = jAjaxInfo.html();

                  dfd.resolve(strHtml);
               });
            }).promise();
         },

         doTooltipHover = function (pinData, bHover) {
            if (!pinData) {
               return;
            }
            var strSchoolId = pinData.getId();
            m_schoolPinLayer.setShapeVisibility(pinData, bHover);
            m_schoolPinLayer.setPinHighlighted(strSchoolId, bHover);
            $("#schoolRecord_" + strSchoolId).toggleClass("hover", bHover);
         },

         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            clickTemplate: m_jClickTemplate,
            initClickTooltip: initClickTooltip,
            getClickHtml: function (pinData) {
               return doTooltipHtml(pinData, "#schoolSummaryClickOverlay");
            },

            onShowClickTooltip: function (pinData) {
               if (!pinData) {
                  return;
               }
               m_schoolPinLayer.setClickPin(pinData, true);
               initShape($("#schoolSummaryClickOverlay"), pinData);
               doTooltipHover(pinData, true);
            },
            onHideClickTooltip: function (pinData) {
               if (!pinData) {
                  return;
               }
               m_schoolPinLayer.setClickPin(pinData, false);
               doTooltipHover(pinData, false);
            },
            onShowHoverTooltip: function (pinData) {
               if (!pinData) {
                  return;
               }
               initShape($("#schoolSummaryHoverOverlay"), pinData);
               doTooltipHover(pinData, true);
            },
            onHideHoverTooltip: function (pinData) {
               if (!pinData) {
                  return;
               }
               doTooltipHover(pinData, false);
            },

            getHoverHtml: function (pinData) {
               return doTooltipHtml(pinData, "#schoolSummaryHoverOverlay");
            },
            hoverOffset: {
               x: 3, //1 + 510,
               y: -73, //-73 + 147,
               tip: -4
            },
            clickOffset: {
               x: 3, //9 + 510,
               y: -73, //-73 + 147,
               tip: -4
            }
         }),
         initialize = function () {};

      self.showClickTooltip = m_tooltipManager.showClickTooltip;
      self.showHoverTooltip = m_tooltipManager.showHoverTooltip;
      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.hideTooltipByPinData = m_tooltipManager.hideTooltipByPinData;
      self.clear = m_tooltipManager.clear;

      self.setLayer = function (layer) {
         m_schoolPinLayer = layer;
      };

      initialize();
   };
});
